import { ESalaryRange, SALARY_RANGES } from '@constants';
import { Select } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DescriptionWrapper, Wrapper } from './SalaryRangeSelector.styles';

type SalaryRangeSelectorProps = {
  value?: ESalaryRange;
  onChange?: (value: ESalaryRange) => void;
  allowClear?: boolean;
  disabled?: boolean;
  disableDescription?: boolean;
  placeholder?: string;
};

export const SalaryRangeSelector: React.FC<SalaryRangeSelectorProps> = ({
  value,
  onChange,
  allowClear = false,
  disabled = false,
  disableDescription = false,
  placeholder
}) => {
  const { t } = useTranslation('DefaultTranslations');
  const options = useMemo(
    () =>
      SALARY_RANGES.map(salaryRange => ({
        label: t(salaryRange),
        value: salaryRange
      })),
    []
  );

  return (
    <Wrapper>
      {!disableDescription && <DescriptionWrapper>{t('THIS_DATA_IS_PRIVATE')}</DescriptionWrapper>}
      <Select
        showSearch
        value={value}
        options={options}
        onChange={onChange}
        allowClear={allowClear}
        placeholder={placeholder || t('CHOOSE_AN_OPTION')}
        style={{ minWidth: '200px' }}
        disabled={disabled}
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
      />
    </Wrapper>
  );
};
